import { Component, Input } from '@angular/core';
import { DeactivatePropertyComponent } from '../deactivate-property/deactivate-property.component';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PropertyDetailDto } from '../../../domain/model/properties/propertyDetailDto';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-property-footer-options',
  templateUrl: './property-footer-options.component.html',
  styleUrl: './property-footer-options.component.css'
})
export class PropertyFooterOptionsComponent {
  @Input() model!: PropertyDetailDto;
  @Input() currentForm!: FormGroup;
  constructor(private readonly router: Router, private overlay: Overlay, public dialogRef: MatDialog){}
  openDeactivateModal(): void {
    const dialogRef = this.dialogRef.open(DeactivatePropertyComponent, {
      width: '479px',
      data: {id: this.model.rentalPropertyInfo.id},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });

  }
}
